// 客户管理
import operationManage from '@/views/operationManage/operationManage'
import customerManage from '@/views/operationManage/customerManage'
import employeeList from '@/views/operationManage/employeeList'
import permissionIntro from '@/views/operationManage/permissionIntro'
import versionInfo from '@/views/operationManage/versionInfo'
import operationLog from '@/views/operationManage/operationLog'
import ecConvertLink from '@/views/operationManage/ecConvertLink'
export default {
  path: '/operationManage',
  name: 'operationManage',
  component: operationManage,
  meta: {
    keepAlive: true,
    title: '客户管理',
    code: 'page:operationManage',
    activeName: '/operationManage',
    permission: 'clientele',
    name: 'customerManage'
  },
  children: [
    {
      path: 'customerManage',
      name: 'customerManage',
      component: customerManage,
      meta: {
        keepAlive: true,
        title: '客户管理',
        iconName: 'icon-client'
      },
      children: [
        {
          path: 'employeeList',
          name: 'employeeList',
          component: employeeList,
          meta: {
            keepAlive: true
          }
        }
      ]
    },
    {
      path: 'permissionIntro',
      name: 'permissionIntro',
      component: permissionIntro,
      meta: {
        keepAlive: true,
        title: '功能权限',
        iconName: 'icon-permission'
      }
    },
    {
      path: 'versionInfo',
      name: 'versionInfo',
      component: versionInfo,
      meta: {
        keepAlive: true,
        title: '版本更新',
        iconName: 'icon-gengxin'
      }
    },
    {
      path: 'operationLog',
      name: 'operationLog',
      component: operationLog,
      meta: {
        keepAlive: true,
        title: '操作日志',
        iconName: 'icon-menuCz'
      }
    },
    {
      path: 'ecConvertLink',
      name: 'ecConvertLink',
      component: ecConvertLink,
      meta: {
        keepAlive: true,
        title: '电商转链',
        iconName: 'icon-link'
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/modules/clientele.js